<template>
  <div class="bg-lightGray page-candidate mainPad">
    <div class="container">
      <div class="row">
        <div class="col-md-12 pt-0 pb-0">
          <nav area-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="/recruit">Home</a></li>
              <li class="breadcrumb-item">
                <a href="/recruit/client-job-dashboard">Dashboard</a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">Candidate profile</li>
            </ol>
          </nav>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="col rounded-lg detail-box">
            <div class="row content user-banner">
              <div class="user-dp text-center">
                <div class="container">
                  <span class="visumeNotification" v-if="!visume"></span>
                  <div class="userDp" @click.prevent="openModal('visume')">
                    <div class="video-input mt-2" v-if="!visume">
                      <span class="userDummy"></span>
                    </div>
                    <div v-show="visume" style="padding: 0">
                      <span class="play-button"></span>
                      <video :key="visume_path" width="210" height="210" class="video-thumbnail" preload="metadata" style="background-color: #4d5b99 !important">
                        <source :src="$S3_bucket_url+visume_path" type="video/mp4" id="visume_thumbnail"/>
                      </video>
                    </div>
                  </div>
                </div>
              </div>

              <div class="user-details" v-if="user">
                <div>
                  <p class="mb-0 lead user-name">{{ user.name }}</p>
                  <p class="mb-0 user-gender" v-if="user_detail">{{ getGender(user_detail.gender) }}</p>
                  <p class="mb-0 lead user-designation">{{ designation }}</p>
                  <p class="text-secondary" v-if="user_city">{{ user_city.city_name}}<span v-if="user_state">,{{ user_state.state_name }}</span></p>
                </div>
                <div class="RVisume mt-6">
                  <p>
                    <a class="txt-blue" @click="viewContact(user.id)"><i class="mdi mdi-comment-account-outline" data-toggle="tooltip" data-placement="top" title="" data-original-title="View visume"></i>View Contact</a>
                  </p>
                  <p v-if="user_detail&&user_detail.resume_path">
                    <a :href="$S3_bucket_url+user_detail.resume_path" class="txt-blue" v-if="user_detail.resume_path"><i class="mdi mdi-download" data-toggle="tooltip" data-placement="top" title="" data-original-title="Download resume"></i>Download Resume</a>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <b-modal id="view-contact" ref="view-contact" size="sm" bod title="Contact Details" hide-footer hide-backdrop centered>
            <ContentLoader viewBox="0 0 250 110" v-if="contact_loading">
              <rect x="0" y="0" rx="3" ry="3" width="250" height="10" />
              <rect x="20" y="20" rx="3" ry="3" width="220" height="10" />
              <rect x="20" y="40" rx="3" ry="3" width="170" height="10" />
              <rect x="0" y="60" rx="3" ry="3" width="250" height="10" />
              <rect x="20" y="80" rx="3" ry="3" width="200" height="10" />
              <rect x="20" y="100" rx="3" ry="3" width="80" height="10" />
            </ContentLoader>
            <div v-else>
              <div class="container text-left" v-if="contact_remaining !== 0 ">
                <p>Views remaining: {{contact_remaining}}</p>
                <!-- <p>Name : {{contact.name}}</p> -->
                <p>Email : {{contact.email}}</p>
                <p>Mobile : {{contact.mobile}}</p>
              </div>
              <div v-else>
                <p v-if="high_usage">We have found  higher usage in your account.For security reasons we are deactivating your package.If this usage from your side, please contact admin at <a href="mailto:recruit@hireclap.com">recruit@hireclap.com</a> to activate your package </p>
                <p v-else>Credits expired <br> <a href="/recruit/package-pricing" target="_blank">Subscribe</a> for more contact access </p>
              </div>
            </div>
          </b-modal>

          <!-- mobile myprofile area end -->

          <div class="adVisumePopup rounded-lg" v-if="!visume && openPopUp">
            <div class="popupWrapper rounded-lg">
              <span class="red-line"></span>
              <span class="closeBtn" @click.prevent="closeVisumePopup" style="cursor: pointer">x</span>
              <div class="row">
                <div class="col-md-5 text-center">
                  <video width="270" height="148" poster="https://s3.ap-south-1.amazonaws.com/www.hireclap.com/Assets/images/maxresdefault.jpg" controls="controls" preload="none">
                    <source src="https://s3.ap-south-1.amazonaws.com/www.hireclap.com/Assets/videos/hireclap-hire-matching-candidates.mp4" type="video/mp4" title="hireclap-visume" alt="hire from video profile"/>
                    <source src="movie.ogg" type="video/ogg" />
                    Your browser does not support the video tag.
                  </video>
                </div>
                <div class="col-md-7">
                  <h2 v-if="user">{{ user.name }}, your visume is not added.</h2>
                  <p> Your face is the best interface. Video profile is a 2 minute snapshot of your profile. Hireclap profiles with video resumes are getting better attention from recruiters. Add visume to your profile now</p>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-content rounded-lg" id="v-pills-tabContent">
            <PersonalDetails v-bind:user="user" v-if="this.user" />
          </div>
        </div>
      </div>
      <VisumeModal :user="user" :open="visumeModal.open" />
    </div>
  </div>
</template>

<script>
const VisumeModal = () => import(/* webpackPrefetch: true */ "@/components/VisumeModal");
const PersonalDetails = () => import(/* webpackPrefetch: true */ "@/components/CandidateProfile");

export default {
  name: "candidate_dashboard",
  components: {
    PersonalDetails: PersonalDetails,
    VisumeModal,
  },
  async beforeMount() {
    window.scrollTo(0, 0);
    let id = this.$route.params.id;
    console.log(this.$route.params);
    this.job_id = this.$route.params.job_id
    let token = this.$cookies.get("hire-employer").token;
    new this.$apiAction().getCandidateProfile(id,this.job_id, token).then((res) => {
      this.user = res.candidate;
      if(this.user.job_type == 2){
        this.user.personal_details = {
          city:{
            city_name:this.user.city_name
          }
        }
        this.user.high_qualification = {
          course:{
            course_name: this.user.course
          },
          branch:{
            branch_name:this.user.branch
          },
          passout_year:this.user.passout_year,
          aggregate_marks: this.user.qualification_perc
        }
      }
      console.log(this.user);
      this.getJobRole();
      this.getUser(this.user);
      this.getContactQuota();
    });
  },
  data() {
    return {
      visumeModal: {
        open: "exit",
      },
      user: null,
      contact: {
        email: "",
        mobile: "",
      },
      showModal: false,
      user_city: {},
      user_state: null,
      user_career: null,
      visume: "",
      visume_path: "",
      jobrole: [],
      selectedTab: "personalDetails",
      selectJob: true,
      selectPersonal: false,
      selectEducation: false,
      selectExperience: false,
      selectCallLeter: false,
      selectFAQ: false,
      selectSettings: false,
      profileImage: null,
      selectedFile: null,
      uploadError: null,
      currentStatus: null,
      uploadFieldName: "photos",
      designation: null,
      openPopUp: false,
      contact_remaining: 0,
      contact_loading:false,
      high_usage: false,
      user_detail:null,
      job_id: null,
      gender: {
        options: [
          { value: 1, text: "Male" },
          { value: 2, text: "Female" },
          { value: 3, text: "Both" },
        ],
      },
    };
  },
  methods: {
    openModal: function (type = "") {
      this.open = type == "" ? this.open : type;
      if (this.open == "profile-pic") {
        this.$refs["profile-pic"].show();
      }
      this.visumeModal.open = "exit";
      this.visumeModal.open = type;
    },
    getUser(user) {
        this.user = user;
        this.user_city = user?.personal_details?.city;
        this.user_state = this.user_city?.state;
        this.user_detail = user?.personal_details;
        this.user_career = this.user?.careerPreferencesDetail;
        this.visume = user?.personal_details?.video_resume_path;
        this.visume_path = user?.personal_details?.video_resume_path + "#t=0.1";        
    },
    getJobRole: function () {
      new this.$apiAction().getJobrole().then((data) => {
        data.jobroles.forEach((element) => {
          this.jobrole.push({
            value: element.role_id,
            text: element.role,
          });
          if(this.user.job_type == 1){
            if (this.user_career && element.role_id == this.user_career.fst_prefered_role) {
              this.designation = element.role;
            } else if (this.user_career && element.role_id == this.user_career.snd_prefered_role) {
              this.designation = element.role;
            } else if (this.user_career && element.role_id == this.user_career.trd_prefered_role) {
              this.designation = element.role;
            }
          }else{
            if (element.role_id == JSON.parse(this.user.job_role)[0]) {
              this.designation = element.role;
            }
          }
        });
      });
    },
    closeVisumePopup() {
      console.log("here popup");
      this.openPopUp = false;
    },
    viewContact: function (u_id) {
      var token = this.$cookies.get("hire-employer").token;
      this.contact = {};
      if(this.contact_remaining !== 0) {
        this.contact_loading = true;
        var data = {user_id: u_id,client_user_id:this.$route.query.client, view_type:1, job_id:this.job_id}
        new this.$apiAction().viewContact(data,token).then(res => {
          this.contact = res.contact;
          this.contact_loading = false;
          this.showModal = true;
          this.$refs['view-contact'].show();
          if(res.remaining_total) this.contact_remaining = res.remaining_total;
        })
      }else{
        this.contact_loading = false;
        this.$refs['view-contact'].show();
      }
      // new this.$apiAction().viewContact(req_body, token).then((res) => {
      //   this.contact = res.contact;
      //   this.showModal = true;
      // });
    },
    getContactQuota: function(){
      var token = this.$cookies.get("hire-employer").token;
      new this.$apiAction().getFeatureQuota(process.env.VUE_APP_JOB_CONTACT_VIEW_FEATURE_ID, token).then(res => {
        if(res.status) {
          this.contact_remaining = res.remaining_total;
          this.high_usage = res.high_usage;
        }
      });
    },
    getGender(id) {
      let gender = null;
      this.gender.options.forEach((g) => {
        if (g.value == id) {
          gender = g.text;
        }
      });
      return gender;
    },
  },
};
</script>

<style scoped>
video {
  background-color: #0d82ff;
}
.user-banner {
  background: #fff;
  background-size: 100% 106px;
  background-repeat: no-repeat;
  margin-top: -15px;
}
.detail-box {
  margin-bottom: 20px;
}
.userDp {
  width: 157px;
  height: 157px;
  background-color: #0d82ff;

  border-radius: 90%;
  border: solid 2px #fff;
  overflow: hidden;
}
.user-details {
  margin-top: 30px;
  line-height: 27px;
}
.user-details p.text-secondary {
  margin: 0px;
  line-height: 22px;
}
.user-details p span.seperator {
  margin: 0px 15px 0px 15px;
}
.user-name {
  font-size: 25px;
  color: rgb(0, 0, 0);
}
.user-designation {
  font-size: 18px;
  color: rgb(116, 116, 116);
}
.inside-bg {
  background: #e6e7e8;
}
.nav-pills .nav-link.active {
  background: #eef6ff;
  color: #333333;
}
.nav-pills .nav-link:hover {
  color: #007bff;
}
.v-application a {
  font-weight: bold;
  color: #333333;
  border-bottom: solid 1px #e7e7e7;
}
ul.nav-pills {
  padding: 0px !important;
}

@media only screen and (max-width: 640px) {
  .user-dp {
    margin: 0 auto;
  }
  .user-details {
    text-align: center;
    width: 100%;
    margin-top: 0px;
    margin-bottom: 10px;
  }
  .user-details p.mt-4 {
    margin-top: 0px !important;
  }
  .user-name {
    color: #000;
  }
  .user-designation {
    color: #000;
  }
  .profileWrapper {
    padding: 7px !important;
  }
}
</style>

<style>
.video-input {
  border-radius: 10px;
  cursor: pointer;
  color: rgba(37, 38, 50, 0.5);
  padding: 10px 15px;
  width: 157px;
  height: 157px;
}
.user-dp {
  position: relative;
}

.visumeNotification {
  display: block;
  width: 21px;
  height: 21px;
  background: red;
  border-radius: 50%;
  position: absolute;
  right: 22px;
  top: 33px;
  border: solid 2px #fff;
}
.adVisumePopup::before {
  display: block;
  content: "";
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 8px solid #e30020;
  position: absolute;
  margin-top: -8px;
  margin-left: 40px;
}
.popupWrapper {
  overflow: hidden;
  padding: 12px;
}
.closeBtn {
  position: absolute;
  right: 35px;
}
.adVisumePopup {
  background: #e3f6ff;
}
.adVisumePopup h2 {
  font-size: 20px;
  margin-top: 20px;
}
.adVisumePopup p {
  font-size: 14px;
}
.red-line {
  height: 3px;
  background: #e30020;
  display: block;
  margin: -12px -12px 10px -12px;
}
.video-input1 {
  border-radius: 10px;
  border: 2px dashed #00000000;
  cursor: pointer;
  color: rgba(37, 38, 50, 0.5);
  padding: 10px 15px;
}
.video-thumbnail {
  margin: -25px 0px 0px -28px;
  cursor: pointer;
  color: rgba(37, 38, 50, 0.5);
  filter: blur(1px);
}
span.play-button {
  width: 0;
  height: 0;
  border-top: 12px solid transparent;
  border-left: 20px solid rgb(255, 255, 255);
  border-bottom: 12px solid transparent;
  position: absolute;
  z-index: 50;
  left: 0;
  right: 0;
  margin: 0 auto;
  top: 77px;
  cursor: pointer;
}
.video-input:hover,
.video-input1:hover {
  color: #007bff;
}
.add_image {
  position: absolute;
  top: 13px;
  left: 17px;
  opacity: 0;
}
.add_image:hover {
  opacity: 100;
}
.content {
  background: #fff;
  margin-top: 15px;
  padding: 15px;
  border-radius: 10px;
}

.m-show {
  display: none;
}

.float {
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 25px;
  right: 40px;
  background-color: #007bff;
  color: #fff !important;
  border-radius: 50px;
  text-align: center;
  box-shadow: 2px 2px 3px #999;
  padding: 16px 0px;
  outline: none !important;
}

@media only screen and (max-width: 640px) {
  .m-show {
    display: block;
  }
  .m-hide {
    display: none;
  }
}
</style>
